import UUIDFilters from "./UUIDFilters"

function combinedIngressEgress(data, keys) {
    var time_bins = {};

    for (var row of data) {
        let key = keys[row.uuid];

        if (key !== false) {
            if (typeof time_bins[key] == 'undefined') {
                time_bins[key] = {};
            }

            if (typeof time_bins[key][row.start] == 'undefined') {
                time_bins[key][row.start] = {
                    start: row.start,
                    in: 0,
                    out: 0
                };
            }

            time_bins[key][row.start].in += row.in;
            time_bins[key][row.start].out += row.out
        }
    }

    return time_bins;
}

function combinedTimestamps(data, group_size, end_time) {
    var groups = {};
    for (var row of data) {
        var start = Math.ceil(row.start / group_size) * group_size;
        if (start > end_time) {
            start = end_time
        }
        var uuid = row.uuid;
        var key = start + '_' + uuid;

        if (typeof groups[key] == 'undefined') {
            groups[key] = {
                start, uuid,
                in: 0,
                out: 0,
                count: 0
            };
        }

        groups[key].in += row.in;
        groups[key].out += row.out;
        groups[key].count += row.count

    }
    // console.log(groups)
    return Object.values(groups);

}

function combinedIngressEgressContext(data, keys) {
    var time_bins = {};


    for (var row of data) {
        let key = keys[row._id];

        if (key !== false) {
            if (typeof time_bins[key] == 'undefined') {
                time_bins[key] = {
                    in: 0,
                    out: 0
                };
            }


            time_bins[key].in += row.total_in;
            time_bins[key].out += row.total_out
        }
    }

    return time_bins;
}

function padEmptyData(data, timestamps) {


    for (var group in data) {
        for (var timestamp of timestamps) {
            if (typeof data[group][timestamp] == 'undefined') {

                data[group][timestamp] = {
                    in: 0,
                    out: 0,
                    start: timestamp
                }
            }
        }
    }


    return data;
}

function convertToStacked(data, keys) {
    var cumulative = {};
    var output = {};
    for (var key of keys) {
        if (typeof data[key] != 'undefined') {
            for (var index in data[key]) {
                var timestamp = data[key][index].start
                if (typeof cumulative[timestamp] == 'undefined') {
                    cumulative[timestamp] = {
                        in: 0,
                        out: 0,
                        start: timestamp
                    }
                }

                if (typeof output[key] == 'undefined') {
                    output[key] = {};
                }

                if (typeof output[key][timestamp] == 'undefined') {
                    output[key][timestamp] = {};
                }

                cumulative[timestamp].in += data[key][index].in;
                cumulative[timestamp].out += data[key][index].out;

                output[key][timestamp].in = cumulative[timestamp].in;
                output[key][timestamp].out = cumulative[timestamp].out;
                output[key][timestamp].start = timestamp;

            }
        }
    }


    return output;
}

function convertToCumulative(data, context_obj) {

    var out = {};

    for (var group_id in data) {

        let [start_in, start_out] = [0, 0]
        if (context_obj[group_id]) {
            start_in = context_obj[group_id].in;
            start_out = context_obj[group_id].out;
        }

        let as_list = Object.values(data[group_id]).sort((a, b) => a.start - b.start).map((row) => {
            start_in += row.in;
            start_out += row.out;

            return {
                start: row.start,
                in: start_in,
                out: start_out
            };
        });

        out[group_id] = {};

        for (var row of as_list) {
            out[group_id][row.start] = row;
        }


    }

    return out;
}

function convertToNetIngressEgress(data) {
    return data.map(function (row) {
        return data.in - data.out;
    })
}

function generateTimestamps(start_time, end_time, group_size) {
    var first = Math.ceil(start_time / group_size) * group_size;

    var ret = [];
    if(start_time != first){
        ret.push(start_time)
    }
    for (var count = first; count < end_time; count += group_size) {
        ret.push(count);
    }

    ret.push(end_time)

    return ret;
}

function addFlowRate(data, group_size) {
    group_size /= 60;
    for (var key in data) {
        for (var timestamp in data[key]) {
            let row = data[key][timestamp];
            row.in_rate_minute = row.in / group_size;
            row.out_rate_minute = row.out / group_size;
            row.net_rate_minute = row.in_rate_minute - row.out_rate_minute;
        }
    }


    return data;
}


export default function processCharts(data, context, metadata, group_size) {

    const filters = UUIDFilters;
    // debugger;

    data = combinedTimestamps(data, group_size, metadata.end_time)

    let timestamps = generateTimestamps(metadata.start_time, metadata.end_time, group_size)

    var charts = {};

    for (var group_type in filters) {
        charts[group_type] = {};


        var combined_context = combinedIngressEgressContext(context, filters[group_type].keys);
        charts[group_type].flow = combinedIngressEgress(data, filters[group_type].keys);
        charts[group_type].flow = padEmptyData(charts[group_type].flow, timestamps);
        charts[group_type].flow = addFlowRate(charts[group_type].flow, group_size);
        charts[group_type].stacked_flow = convertToStacked(charts[group_type].flow, Object.keys(filters[group_type].groups))
        charts[group_type].stacked_flow = addFlowRate(charts[group_type].stacked_flow, group_size);

        charts[group_type].accumulative = convertToCumulative(charts[group_type].flow, combined_context)
        charts[group_type].stacked_accumulative = convertToStacked(charts[group_type].accumulative, Object.keys(filters[group_type].groups))

    }

    var timestamp_groups = {};

    for (var group_type in charts) {
        for (var data_format in charts[group_type]) {
            for (var group_name in charts[group_type][data_format]) {

                for (var index in charts[group_type][data_format][group_name]) {
                    var timestamp = charts[group_type][data_format][group_name][index].start;
                    // console.log(index)
                    if (typeof timestamp == 'undefined') {
                        debugger;
                    }

                    if (!timestamp_groups[timestamp]) {
                        timestamp_groups[timestamp] = {};
                    }

                    if (!timestamp_groups[timestamp][group_type]) {
                        timestamp_groups[timestamp][group_type] = {};
                    }

                    if (!timestamp_groups[timestamp][group_type][data_format]) {
                        timestamp_groups[timestamp][group_type][data_format] = {};
                    }

                    if (!timestamp_groups[timestamp][group_type][data_format][group_name]) {
                        timestamp_groups[timestamp][group_type][data_format][group_name] = {};
                    }

                    timestamp_groups[timestamp][group_type][data_format][group_name] = charts[group_type][data_format][group_name][index]
                }

            }
        }
    }

    return {
        timestamps, filters, charts, timestamp_groups
    };
}